/* global locales */
'use strict';

import angular from 'angular';
import 'ng-file-upload';
import 'angular-bootstrap';
import 'angular-sanitize';
import 'ui-select';
import locales from '../../locale';
import './recipesServices';

const recipesControllers = angular.module('applicationModule.recipesControllers', [
    'ngSanitize',
    'applicationModule.recipesServices',
    'ui.bootstrap',
    'ui.select'
]);

recipesControllers.controller('RecipesController', ['$scope', '$rootScope', '$state', '$stateParams', '$modal', 'NgTableParams', 'growl', 'Recipe', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $state, $stateParams, $modal, NgTableParams, growl, Recipe, AppsoupAPI, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('recipes');

    $scope.checkedRecipes = [];
    $scope.app_id = $stateParams.application_id;
    $scope.search = {};
    $scope.searchItem = null;
    $scope.check = false;

    $scope.promotions = [];

    let refresh = true;

    if (angular.isDefinedNotNull($stateParams.page)) {
        $scope.search.page = $stateParams.page;
    }

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Recipe.getList($scope.app_id, params._params)
                .then(function (response) {
                    $scope.promotions = response.promotions;
                    $scope.search.page = response.recipes.current_page;
                    $scope.package_id = response.package_id;

                    if (angular.isDefined(response.statuses)) {
                        $scope.statuses = Object.keys(response.statuses).map(function (key) {
                            return response.statuses[key].status;
                        });
                    }

                    if (angular.isDefinedNotNull($stateParams.searchRecipe)) {
                        $scope.search = $stateParams.searchRecipe;
                        $scope.searchRecipe($scope.search);
                    }

                    params.total(response.recipes.total);
                    params.count(response.recipes.per_page);
                    params.page(response.recipes.current_page);

                    return response.recipes.data;
                }).finally(function () {
                    $scope.isLoading = false;
                    $scope.isFind = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });


    $scope.removeRecipe = function (id, index) {
        Recipe.remove(id).then(function (result) {
            let data = result.data;

            if (data.success) {
                growl.success('MODULES.RECIPES.GROWL.RECIPE.SUCCESS.DELETED');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.RECIPES.GROWL.RECIPE.ERROR.DELETED');
            }
        });
    };

    $scope.searchRecipe = function (search) {
        $scope.isFind = true;
        $scope.search.page = 1;
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.title)) {
            $scope.tableParams._params.title = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.promotions)) {
            $scope.tableParams._params.promotions = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.status)) {
            $scope.tableParams._params.status = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.external_id)) {
            $scope.tableParams._params.external_id = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.slug)) {
            $scope.tableParams._params.slug = undefined;
        }
        $stateParams.searchRecipe = null;
        $scope.searchItem = null;
    };

    $scope.selectRecipe = function (id) {
        $scope.checkedRecipes = angular.selectElement($scope.checkedRecipes, id);
    };

    $scope.selectAllRecipes = function (item) {
        $scope.checkedRecipes = angular.selectAllElements($scope.checkedRecipes, item);
    };

    $scope.checkSelectedRecipes = function (item) {
        return angular.checkSelectedElements($scope.checkedRecipes, item);
    };

    function refreshData() {
        $scope.searchRecipe({refresh: refresh});
        refresh = !refresh;
        $scope.checkedRecipes = [];
    }

    $scope.changeStatuses = function (status) {
        Recipe.changeStatuses($scope.checkedRecipes, status)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.RECIPES.GROWL.RECIPE.SUCCESS.BULK_EDITED');
                } else {
                    growl.error('MODULES.RECIPES.GROWL.RECIPE.ERROR.BULK_EDITED');
                }
            })
            .catch(function () {
                growl.error('MODULES.RECIPES.GROWL.RECIPE.ERROR.BULK_EDITED');
            })
            .finally(function () {
                refreshData();
            });
    };

    $scope.bulkDelete = function () {
        Recipe.bulkDelete($scope.checkedRecipes)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.RECIPES.GROWL.RECIPE.SUCCESS.BULK_DELETED');
                } else {
                    growl.error('MODULES.RECIPES.GROWL.RECIPE.ERROR.BULK_DELETED');
                }
            })
            .catch(function () {
                growl.error('MODULES.RECIPES.GROWL.RECIPE.ERROR.BULK_DELETED');
            })
            .finally(function () {
                refreshData();
            });
    };

    $scope.$watch('search', function () {
        if (angular.isDefinedNotNull($scope.search.page)) {
            $scope.tableParams._params.page = $scope.search.page;
        }
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);
}]);

recipesControllers.controller('RecipeController', ['$scope', '$rootScope', '$state', '$stateParams', 'growl', 'Recipe', '$filter', function ($scope, $rootScope, $state, $stateParams, growl, Recipe, $filter) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});

    $scope.editMode = false;
    var appId = $stateParams.application_id;
    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.recipe = {
        app_id: appId,
        attributes: {}
    };
    $scope.tags = [];
    $scope.promotions = [];
    $scope.categories = [];
    $scope.headerTitle = [];
    $scope.recipes_attributes = {};

    function loadDefaultAttributes() {
        Recipe.getAttributes(appId).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.recipes_attributes = data.attributes;
                angular.forEach($scope.recipes_attributes, function (attribute, key) {
                    if (!$scope.recipe.attributes[key] && $scope.recipes_attributes[key].default) {
                        $scope.recipe.attributes[key] = $scope.recipes_attributes[key].default;
                    }
                });
            }
        });
    }

    if (angular.isDefined($stateParams.recipeId)) {
        $scope.editMode = true;
    }

    if ($scope.editMode) {
        Recipe.getWithStatusEdit($stateParams.recipeId, appId).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.recipe = data.recipes;
                if (angular.isDefinedNotNull($scope.recipe.image)) {
                    $scope.fileUploaded = true;
                }
                $scope.headerTitle.push('-');
                $scope.headerTitle.push($scope.recipe.title);

            } else {
                growl.error('MODULES.RECIPES.GROWL.RECIPE.ERROR.' + data.error);
            }
        }).catch(function () {
            $state.go('appsoup.application.recipes', {application_id: appId});
            growl.error('ERROR.EMPTY_DATA');
        }).finally(function () {
            $rootScope.doingResolve = false;
            loadDefaultAttributes();
        });
    } else {
        loadDefaultAttributes();
    }


    $scope.searchTags = function (text) {
        text = $filter('removeSpecial')(text);

        Recipe.search(appId, text).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.tags = data.tags;
            } else {
                growl.error('MODULES.RECIPES.GROWL.RECIPE.ERROR.' + data.error);
            }
        });
    };

    $scope.searchPromotion = function (text) {
        text = $filter('removeSpecial')(text);

        Recipe.searchPromotion(appId, text).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.promotions = data.promotions;
            } else {
                growl.error('MODULES.RECIPES.GROWL.RECIPE.ERROR.' + data.error);
            }
        });
    };

    $scope.searchCategories = function (text) {
        text = $filter('removeSpecial')(text);

        Recipe.searchCategories(appId, text).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.categories = data.categories;
            } else {
                growl.error('MODULES.RECIPES.GROWL.RECIPE.ERROR.' + data.error);
            }
        });
    };

    $scope.changeTags = function () {
        if (angular.isDefined($scope.recipe.tags)) {
            var tempTags = [];
            angular.forEach($scope.recipe.tags, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value) && tempTags.indexOf(value) === -1) {
                    tempTags.push(value);
                }
            });
            $scope.recipe.tags = tempTags;
        }
    };

    $scope.changeCategories = function () {
        if (angular.isDefined($scope.recipe.category)) {
            var tempTags = [];
            angular.forEach($scope.recipe.category, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value) && tempTags.indexOf(value) === -1) {
                    tempTags.push(value);
                }
            });
            $scope.recipe.category = tempTags;
        }
    };

    $scope.save = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        Recipe.save($scope.recipe, $scope.upload, $scope.editMode).then(function (result) {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.RECIPES.GROWL.RECIPE.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                $state.go('appsoup.application.recipes', {
                    application_id: appId,
                    searchRecipe: $stateParams.searchRecipe,
                    page: $stateParams.page
                }, {reload: true});
            } else {
                if (typeof data.error === 'object') {
                    if (data.error.image) {
                        $scope.fileError = true;
                    }
                    $scope.formErrors = data.error;
                } else {
                    growl.error('MODULES.RECIPES.GROWL.RECIPE.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                }
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.recipes', {
            application_id: appId, searchRecipe: $stateParams.searchRecipe,
            page: $stateParams.page
        }, {reload: true});
    };

    $scope.inputErrors = {
        'title': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'recipe_time': [{type: '$invalid', msg: 'FORM.ERRORS.FORMAT'}],
        'recipe_for_persons': [{type: '$invalid', msg: 'FORM.ERRORS.FORMAT'}],
        'recipe_calories': [{type: '$invalid', msg: 'FORM.ERRORS.FORMAT'}],
        'recipe_cost': [{type: '$invalid', msg: 'FORM.ERRORS.FORMAT'}]
    };
}]);

recipesControllers.controller('RecipeIngredientsController', ['$scope', '$rootScope', '$state', '$stateParams', '$modal', 'NgTableParams', 'growl', 'RecipeIngredient', 'AppsoupAPI', 'Permissions', 'Recipe', '$filter', '$timeout', function ($scope, $rootScope, $state, $stateParams, $modal, NgTableParams, growl, RecipeIngredient, AppsoupAPI, Permissions, Recipe, $filter, $timeout) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.app_id = $stateParams.application_id;
    $scope.isDropped = false;

    $scope.writeAccess = Permissions.hasWriteAccess('recipes');

    $scope.recipeId = $stateParams.recipeId;
    $scope.headerTitle = [];

    $scope.checkedIngredients = [];
    var refresh = true;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getOrderTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return RecipeIngredient.getList($scope.app_id, $scope.recipeId, params._params).then(function (response) {
                params.total(response.ingredients.total);
                params.count(response.ingredients.per_page);
                params.page(response.ingredients.current_page);
                $scope.package_id = response.package_id;

                return response.ingredients.data;
            }).finally(function () {
                $scope.isLoading = false;
                $scope.isFind = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    Recipe.get($scope.recipeId).then(function (result) {
        let data = result.data;
        if (data.success) {
            $scope.recipe = data.recipes;

            $scope.headerTitle.push('(' + $scope.recipe.title + ')');
        } else {
            growl.error('MODULES.RECIPES.GROWL.RECIPE.ERROR.' + data.error);
        }
    }).catch(function () {
        $state.go('appsoup.application.recipes', {application_id: $scope.app_id});
        growl.error('ERROR.EMPTY_DATA');
    }).finally(function () {
        $rootScope.doingResolve = false;
    });

    $scope.removeIngredient = function (id, index) {
        RecipeIngredient.remove(id).then(function (result) {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.RECIPES.GROWL.INGREDIENT.SUCCESS.DELETED');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.RECIPES.GROWL.INGREDIENT.ERROR.DELETED');
            }
        });
    };

    $scope.selectIngredient = function (id) {
        $scope.checkedIngredients = angular.selectElement($scope.checkedIngredients, id);
    };

    $scope.selectAllIngredients = function (item) {
        $scope.checkedIngredients = angular.selectAllElements($scope.checkedIngredients, item);
    };

    $scope.checkSelectedIngredients = function (item) {
        return angular.checkSelectedElements($scope.checkedIngredients, item);
    };

    $scope.searchIngredients = function (search) {
        $scope.isFind = true;
        $scope.search.page = 1;
        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };

    function refreshData() {
        $scope.searchIngredients({refresh: refresh});
        refresh = !refresh;
        $scope.checkedIngredients = [];
    }

    $scope.bulkDelete = function () {
        RecipeIngredient.bulkDelete($scope.checkedIngredients)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.RECIPES.GROWL.INGREDIENT.SUCCESS.BULK_DELETED');
                } else {
                    growl.error('MODULES.RECIPES.GROWL.INGREDIENT.ERROR.BULK_DELETED');
                }
            })
            .catch(function () {
                growl.error('MODULES.RECIPES.GROWL.INGREDIENT.ERROR.BULK_DELETED');
            })
            .finally(function () {
                refreshData();
            });
    };

    $scope.changeStatuses = function (status) {
        RecipeIngredient.changeStatuses($scope.checkedIngredients, status)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.RECIPES.GROWL.INGREDIENT.SUCCESS.BULK_EDITED');
                } else {
                    growl.error('MODULES.RECIPES.GROWL.INGREDIENT.ERROR.BULK_EDITED');
                }
            })
            .catch(function () {
                growl.error('MODULES.RECIPES.GROWL.INGREDIENT.ERROR.BULK_EDITED');
            })
            .finally(function () {
                refreshData();
            });
    };

    // drag&drop
    $scope.treeOptions = {
        beforeDrag: function () {
            return true;
        },

        dropped: function () {
            $scope.isDropped = true;
            $timeout(function () {
                $scope.saveOrder($scope.tableParams.data);
            }, 1000);
        }
    };

    $scope.saveOrder = function (data) {
        var tmpData = {
            application_id: $scope.app_id,
            recipe_id: $scope.recipeId,
            data: data
        };

        RecipeIngredient.changeOrderIngredient(tmpData)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    // successful changed orders
                }
            })
            .finally(function () {
                $scope.isDropped = false;
            });
    };
}]);

recipesControllers.controller('RecipeIngredientController', ['$scope', '$rootScope', '$state', '$stateParams', 'growl', 'RecipeIngredient', 'Recipe', function ($scope, $rootScope, $state, $stateParams, growl, RecipeIngredient, Recipe) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});

    $scope.editMode = false;
    var appId = $stateParams.application_id;
    $scope.recipeId = $stateParams.recipeId;
    $scope.recipe_ingredients_attributes = {};
    $scope.ingredientId = $stateParams.ingredientId;
    $scope.ingredient = {
        app_id: appId,
        recipe_id: $scope.recipeId,
        attributes: {}
    };
    $scope.headerTitle = [];

    function loadDefaultAttributes() {
        RecipeIngredient.getAttributes(appId).then(function (result) {
            let data = result.data;
            if (data.success) {
                $scope.recipe_ingredients_attributes = data.attributes;
                angular.forEach($scope.recipe_ingredients_attributes, function (attribute, key) {
                    if (!$scope.ingredient.attributes[key] && $scope.recipe_ingredients_attributes[key].default) {
                        $scope.ingredient.attributes[key] = $scope.recipe_ingredients_attributes[key].default;
                    }
                });
            }
        });
    }

    if (angular.isDefined($stateParams.ingredientId)) {
        $scope.editMode = true;
    }

    if ($scope.editMode) {
        RecipeIngredient.get($stateParams.ingredientId, appId).then(function (result) {
            let data = result.data;
            if (data.success) {
                $scope.ingredient = data.ingredient;

                $scope.headerTitle.push('-');
                $scope.headerTitle.push($scope.ingredient.title);
            } else {
                growl.error('MODULES.RECIPES.GROWL.INGREDIENT.ERROR.' + data.error);
            }
        }).catch(function () {
            $state.go('appsoup.application.ingredients', {application_id: appId});
            growl.error('ERROR.EMPTY_DATA');
        }).finally(function () {
            $rootScope.doingResolve = false;
            loadDefaultAttributes();
        });
    } else {
        loadDefaultAttributes();
    }

    Recipe.get($scope.recipeId, appId).then(function (result) {
        let data = result.data;
        if (data.success) {
            $scope.recipe = data.recipes;

            $scope.headerTitle.push('(' + $scope.recipe.title + ')');
        } else {
            growl.error('MODULES.RECIPES.GROWL.RECIPE.ERROR.' + data.error);
        }
    }).finally(function () {
        $rootScope.doingResolve = false;
    });

    $scope.save = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        RecipeIngredient.save($scope.ingredient, $scope.editMode).then(function (result) {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.RECIPES.GROWL.INGREDIENT.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                $state.go('appsoup.application.ingredients', {application_id: appId, recipeId: $scope.recipeId});
            } else {
                if (typeof data.error === 'object') {
                    $scope.formErrors = data.error;
                } else {
                    growl.error('MODULES.RECIPES.GROWL.INGREDIENT.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                }
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.ingredients', {application_id: appId, recipeId: $scope.recipeId});
    };

    $scope.inputErrors = {
        'title': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'quantity': [{type: '$invalid', msg: 'FORM.ERRORS.FORMAT'}, {
            error: 'min',
            msg: 'MODULES.RECIPES.ERROR.INGREDIENT.QUANTITY'
        }],
        'quantity_measure': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}]
    };
}]);

recipesControllers.controller('RecipePreparationsController', ['$scope', '$rootScope', '$state', '$stateParams', '$modal', 'NgTableParams', 'growl', 'RecipePreparation', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $state, $stateParams, $modal, NgTableParams, growl, RecipePreparation, AppsoupAPI, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('recipes');

    $scope.app_id = $stateParams.application_id;
    $scope.recipeId = $stateParams.recipeId;
    $scope.checkedPreparations = [];

    let refresh = true;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getOrderTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;

            return RecipePreparation.getList($scope.app_id, $scope.recipeId, params._params).then(function (response) {
                params.total(response.preparations.total);
                params.count(response.preparations.per_page);
                params.page(response.preparations.current_page);

                return response.preparations.data;
            }).finally(function () {
                $scope.isLoading = false;
                $scope.isFind = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.changeOrder = function ($event, key1, key2) {
        var data = $scope.tableParams.data;

        $event.stopImmediatePropagation();
        RecipePreparation.changeOrder({
            ids: [$scope.tableParams.data[key1].id, $scope.tableParams.data[key2].id],
            application_id: $scope.app_id
        }).then(function (response) {
            if (response.data.success) {
                data = angular.changeOrderResponse(data, key1, key2);
            }
        });
        $scope.tableParams.data = data;
    };

    $scope.removePreparation = function (id, index) {
        RecipePreparation.remove(id).then(function (result) {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.RECIPES.GROWL.PREPARATION.SUCCESS.DELETED');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.RECIPES.GROWL.PREPARATION.ERROR.DELETED');
            }
        });
    };

    $scope.selectPreparation = function (id) {
        $scope.checkedPreparations = angular.selectElement($scope.checkedPreparations, id);
    };

    $scope.selectAllPreparations = function (item) {
        $scope.checkedPreparations = angular.selectAllElements($scope.checkedPreparations, item);
    };

    $scope.checkSelectedPreparations = function (item) {
        return angular.checkSelectedElements($scope.checkedPreparations, item);
    };

    $scope.searchPreparations = function (search) {
        $scope.isFind = true;
        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };

    function refreshData() {
        $scope.searchPreparations({refresh: refresh});
        refresh = !refresh;
        $scope.checkedPreparations = [];
    }

    $scope.bulkDelete = function () {
        RecipePreparation.bulkDelete($scope.checkedPreparations)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.RECIPES.GROWL.PREPARATION.SUCCESS.BULK_DELETED');
                } else {
                    growl.error('MODULES.RECIPES.GROWL.PREPARATION.ERROR.BULK_DELETED');
                }
            })
            .catch(function () {
                growl.error('MODULES.RECIPES.GROWL.PREPARATION.ERROR.BULK_DELETED');
            })
            .finally(function () {
                refreshData();
            });
    };
}]);

recipesControllers.controller('RecipePreparationController', ['$scope', '$rootScope', '$state', '$stateParams', 'growl', 'RecipePreparation', function ($scope, $rootScope, $state, $stateParams, growl, RecipePreparation) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});

    $scope.editMode = false;
    const appId = $stateParams.application_id;
    $scope.recipeId = $stateParams.recipeId;
    $scope.preparationId = $stateParams.preparationId;
    $scope.imageRequired = true;
    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.preparation = {
        app_id: appId,
        recipe_id: $scope.recipeId
    };
    $scope.preparation.image = null;

    if (angular.isDefined($stateParams.preparationId)) {
        $scope.editMode = true;
    }

    if ($scope.editMode) {
        RecipePreparation.get($stateParams.preparationId, appId).then(function (result) {
            let data = result.data;
            if (data.success) {
                $scope.preparation = data.preparation;
                if (angular.isDefinedNotNull($scope.preparation.image)) {
                    $scope.imageRequired = false;
                    $scope.fileUploaded = true;
                }
            } else {
                growl.error('MODULES.RECIPES.GROWL.PREPARATION.ERROR.' + data.error);
            }
        }).catch(function () {
            $state.go('appsoup.application.preparations', {application_id: appId, recipeId: $scope.recipeId});
            growl.error('ERROR.EMPTY_DATA');
        }).finally(function () {
            $rootScope.doingResolve = false;
        });
    }

    $scope.save = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        RecipePreparation.save($scope.preparation, $scope.upload, $scope.editMode).then(function (result) {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.RECIPES.GROWL.PREPARATION.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                $state.go('appsoup.application.preparations', {application_id: appId, recipeId: $scope.recipeId});
            } else {
                if (typeof data.error === 'object') {
                    if (data.error.image) {
                        $scope.fileError = true;
                    }
                    $scope.formErrors = data.error;
                } else {
                    growl.error('MODULES.RECIPES.GROWL.PREPARATION.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                }
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.preparations', {application_id: appId, recipeId: $scope.recipeId});
    };

    $scope.inputErrors = {
        'step_no': [{type: '$invalid', msg: 'FORM.ERRORS.FORMAT'}],
        'description': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}]
    };
}]);

recipesControllers.controller('RecipeIngredientsEditController', ['$scope', '$rootScope', '$state', '$stateParams', '$modal', 'NgTableParams', 'growl', 'RecipeIngredient', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $state, $stateParams, $modal, NgTableParams, growl, RecipeIngredient, AppsoupAPI, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    var appId = $stateParams.application_id;
    $scope.ingredients_data = [];

    $scope.writeAccess = Permissions.hasWriteAccess('recipes');

    $scope.recipeId = $stateParams.recipeId;
    $scope.editMode = true;
    $scope.headerTitle = [];
    $scope.ingredients = {
        app_id: appId,
        recipe_id: $scope.recipeId
    };
    $scope.recipe = {
        title: ''
    };

    RecipeIngredient.getIngredients(appId, $scope.recipeId).then(function (response) {
        $scope.ingredients_data = response.ingredients.data;
        $scope.recipe.title = response.recipe.title;
    }).finally(function () {
        $scope.isFind = false;
    });

    $scope.save = function () {
        $scope.isLoading = true;
        for (var i = 0; i < $scope.ingredients_data.length; i++) {
            RecipeIngredient.save($scope.ingredients_data[i], $scope.editMode).then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.RECIPES.GROWL.INGREDIENT.SUCCESS.EDITED');
                    $state.go('appsoup.application.ingredients', {
                        application_id: appId,
                        recipeId: $scope.recipeId
                    });
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.RECIPES.GROWL.INGREDIENT.ERROR.EDITED');
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.ingredients', {application_id: appId, recipeId: $scope.recipeId});
    };
}]);

recipesControllers.controller('RecipeAuthorsController', ['$scope', '$rootScope', '$state', '$stateParams', '$modal', 'NgTableParams', 'growl', 'AppsoupAPI', 'Permissions', 'RecipeAuthor', function ($scope, $rootScope, $state, $stateParams, $modal, NgTableParams, growl, AppsoupAPI, Permissions, RecipeAuthor) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('recipes');
    $scope.app_id = $stateParams.application_id;

    $scope.search = {};
    $scope.searchItem = null;
    $scope.checkedAuthors = [];
    $scope.check = false;

    var refresh = true;

    if (angular.isDefinedNotNull($stateParams.page)) {
        $scope.search.page = $stateParams.page;
    }

    $scope.tableParams = new NgTableParams(AppsoupAPI.getExternalIdTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;

            return RecipeAuthor.getList($scope.app_id, params._params).then(function (response) {
                params.total(response.authors.total);
                params.count(response.authors.per_page);
                params.page(response.authors.current_page);

                if (angular.isDefinedNotNull($stateParams.searchAuthor)) {
                    $scope.search = $stateParams.searchAuthor;
                    $scope.searchAuthor($scope.search);
                }

                return response.authors.data;
            }).finally(function () {
                $scope.isLoading = false;
                $scope.isFind = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.removeAuthor = function (id, index) {
        RecipeAuthor.remove(id).then(function (result) {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.RECIPES.GROWL.AUTHORS.SUCCESS.DELETED');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.RECIPES.GROWL.AUTHORS.ERROR.DELETED');
            }
        });
    };

    $scope.searchAuthor = function (search) {
        $scope.isFind = true;
        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.id)) {
            $scope.tableParams._params.id = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.external_id)) {
            $scope.tableParams._params.external_id = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.first_name)) {
            $scope.tableParams._params.first_name = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.last_name)) {
            $scope.tableParams._params.last_name = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.email)) {
            $scope.tableParams._params.email = undefined;
        }
        $stateParams.searchAuthor = null;
        $scope.searchItem = null;
    };

    $scope.selectAuthor = function (id) {
        $scope.checkedAuthors = angular.selectElement($scope.checkedAuthors, id);
    };

    $scope.selectAllAuthors = function (item) {
        $scope.checkedAuthors = angular.selectAllElements($scope.checkedAuthors, item);
    };

    $scope.checkSelectedAuthors = function (item) {
        return angular.checkSelectedElements($scope.checkedAuthors, item);
    };

    function refreshData() {
        $scope.searchAuthor({refresh: refresh});
        refresh = !refresh;
        $scope.checkedAuthors = [];
    }

    $scope.bulkDelete = function () {
        RecipeAuthor.bulkDelete($scope.checkedAuthors)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.RECIPES.GROWL.AUTHORS.SUCCESS.BULK_DELETED');
                } else {
                    growl.error('MODULES.RECIPES.GROWL.AUTHORS.ERROR.BULK_DELETED');
                }
            })
            .catch(function () {
                growl.error('MODULES.RECIPES.GROWL.AUTHORS.ERROR.BULK_DELETED');
            })
            .finally(function () {
                refreshData();
            });
    };

    $scope.$watch('search', function () {
        if (angular.isDefinedNotNull($scope.search.page)) {
            $scope.tableParams._params.page = $scope.search.page;
        }
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);
}]);

recipesControllers.controller('RecipeAuthorController', ['$scope', '$rootScope', '$state', '$filter', '$modal', '$locale', '$stateParams', 'growl', 'RecipeAuthor', function ($scope, $rootScope, $state, $filter, $modal, $locale, $stateParams, growl, RecipeAuthor) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});

    $scope.editMode = false;
    var appId = $stateParams.application_id;
    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.author = {
        app_id: appId,
        attributes: {},
        description: ''
    };
    $scope.headerTitle = [];

    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }
    $scope.tinymceOptions = angular.getTinymceOptions($modal);

    $scope.generateUrl = function (name) {
        if (name) {
            var dict = {'ą': 'a', 'ę': 'e', 'ć': 'c', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ż': 'z', 'ź': 'z'};
            var str = angular.copy(name);
            str = str.replace(/ +/g, '-').toLowerCase();
            str = str.replace(/[^\w ]/g, function (char) {
                return dict[char] || char;
            });
            str = str.replace(/[-]+/g, '-');
            $scope.author.user_site_url = str;
        }
    };

    function loadDefaultAttributes() {
        RecipeAuthor.getAttributes(appId).then(function (result) {
            let data = result.data;
            if (data.success) {
                $scope.recipe_authors_attributes = data.attributes;
                angular.forEach($scope.recipe_authors_attributes, function (attribute, key) {
                    if (!$scope.author.attributes[key] && $scope.recipe_authors_attributes[key].default) {
                        $scope.author.attributes[key] = $scope.recipe_authors_attributes[key].default;
                    }
                });
            }
        });
    }

    if (angular.isDefined($scope.lang) && $scope.lang !== 'en') {
        $scope.tinymceOptions['language'] = $scope.lang;
        $scope.tinymceOptions['language_url'] = '/assets/tinymce/' + $scope.lang + '.js';
    }

    if (angular.isDefined($stateParams.authorId)) {
        $scope.editMode = true;
    }

    if ($scope.editMode) {
        RecipeAuthor.get($stateParams.authorId, appId).then(function (result) {
            let data = result.data;
            if (data.success) {
                $scope.author = data.author;
                if (angular.isDefinedNotNull($scope.author.avatar)) {
                    $scope.fileUploaded = true;
                }
                $scope.headerTitle.push('-');
                $scope.headerTitle.push($scope.author.first_name);
                $scope.headerTitle.push(' ');
                $scope.headerTitle.push($scope.author.last_name);

            } else {
                growl.error('MODULES.RECIPES.GROWL.AUTHORS.ERROR.GET_DATA');
                $state.go('appsoup.application.recipeAuthors', {application_id: appId});
            }
        }).catch(function () {
            $state.go('appsoup.application.recipeAuthors', {application_id: appId});
            growl.error('ERROR.EMPTY_DATA');
        }).finally(function () {
            $rootScope.doingResolve = false;
            loadDefaultAttributes();
        });
    } else {
        loadDefaultAttributes();
    }

    $scope.save = function () {
        $scope.generateUrl($scope.author.user_site_url);
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        RecipeAuthor.save($scope.author, $scope.upload, $scope.editMode).then(function (result) {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.RECIPES.GROWL.AUTHORS.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                $state.go('appsoup.application.recipeAuthors', {application_id: appId});
            } else {
                if (typeof data.error === 'object') {
                    if (data.error.image) {
                        $scope.fileError = true;
                    }
                    $scope.formErrors = data.error;
                } else {
                    growl.error('MODULES.RECIPES.GROWL.AUTHORS.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                }
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.recipeAuthors', {application_id: appId});
    };

    $scope.inputErrors = {
        'first_name': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'last_name': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'avatar': [{type: '$invalid', msg: 'FORM.ERRORS.FORMAT'}],
        'user_site_url': [{error: 'pattern', msg: 'FORM.ERRORS.FORMAT'}]
    };
}]);

recipesControllers.controller('RecipeAllIngredientsController', ['$scope', '$rootScope', '$state', '$modal', '$filter', '$locale', '$stateParams', 'growl', 'NgTableParams', 'Permissions', 'AppsoupAPI', 'RecipeIngredient', function ($scope, $rootScope, $state, $modal, $filter, $locale, $stateParams, growl, NgTableParams, Permissions, AppsoupAPI, RecipeIngredient) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('recipes');
    $scope.app_id = $stateParams.application_id;

    $scope.search = {};
    $scope.searchItem = null;
    $scope.check = false;

    if (angular.isDefinedNotNull($stateParams.page)) {
        $scope.search.page = $stateParams.page;
    }

    $scope.tableParams = new NgTableParams(AppsoupAPI.getTitleTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;

            return RecipeIngredient.getListAll($scope.app_id, params._params).then(function (response) {
                params.total(response.ingredients.total);
                params.count(response.ingredients.per_page);
                params.page(response.ingredients.current_page);

                $scope.search.page = response.ingredients.current_page;
                $scope.package_id = response.package_id;
                if (angular.isDefinedNotNull($scope.searchItem)) {
                    $scope.search = $scope.searchItem;
                    $scope.searchIngredient($scope.search);
                }

                return response.ingredients.data;
            }).finally(function () {
                $scope.isLoading = false;
                $scope.isFind = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    function openModal(ingredient) {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/recipes/all-ingredients/editIngredient.tpl.html',
            controller: 'RecipeAllIngredientsEditModalController',
            animation: true,
            resolve: {
                ingredient: function () {
                    return ingredient;
                }
            }
        });
        modalInstance.result.then(function () {
            $scope.tableParams.reload();
        }).catch(() => {});
    }

    $scope.editIngredientByExternalId = function (externalId) {
        RecipeIngredient.editByExternal(externalId, $scope.app_id).then(function (result) {
            let data = result.data;
            if (data.success) {
                openModal(data.ingredient);
            } else {
                growl.error('ERROR.EMPTY_DATA');
            }
        });
    };

    $scope.searchIngredient = function (search) {
        $scope.isFind = true;
        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.title)) {
            $scope.tableParams._params.title = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.external_id)) {
            $scope.tableParams._params.external_id = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.integration_name)) {
            $scope.tableParams._params.integration_name = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.ingredient_category_id)) {
            $scope.tableParams._params.ingredient_category_id = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.new_integration_name)) {
            $scope.tableParams._params.new_integration_name = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.new_integration_category)) {
            $scope.tableParams._params.new_integration_category = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.integration_attributes)) {
            $scope.tableParams._params.integration_attributes = undefined;
        }
        $stateParams.searchIngredient = null;
        $scope.searchItem = null;
    };

    $scope.$watch('search', function (newVal, oldVal) {
        if (angular.isDefinedNotNull($scope.search.page)) {
            $scope.tableParams._params.page = $scope.search.page;
        }
        if (newVal.title !== oldVal.title) {
            $scope.search.page = 1;
        }
        if (newVal.external_id !== oldVal.external_id) {
            $scope.search.page = 1;
        }
        if (newVal.integration_name !== oldVal.integration_name) {
            $scope.search.page = 1;
        }
        if (newVal.ingredient_category_id !== oldVal.ingredient_category_id) {
            $scope.search.page = 1;
        }
        if (newVal.new_integration_name !== oldVal.new_integration_name) {
            $scope.search.page = 1;
        }
        if (newVal.new_integration_category !== oldVal.new_integration_category) {
            $scope.search.page = 1;
        }
        if (newVal.integration_attributes !== oldVal.integration_attributes) {
            $scope.search.page = 1;
        }
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);

}]);

recipesControllers.controller('RecipeAllIngredientsEditModalController', ['$scope', '$rootScope', '$stateParams', '$state', 'RecipeIngredient', 'ingredient', 'growl', 'Permissions', '$modalInstance', function ($scope, $rootScope, $stateParams, $state, RecipeIngredient, ingredient, growl, Permissions, $modalInstance) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('recipes');
    var app_id = $stateParams.application_id;

    $scope.isLoading = true;

    $scope.recipe_ingredients_attributes = {};
    $scope.editMode = false;
    $scope.ingredient = {
        app_id: app_id,
        attributes: {}
    };

    if (ingredient) {
        $scope.ingredient = ingredient;
        if (ingredient.id) {
            $scope.editMode = true;
        }
    }

    RecipeIngredient.getAttributes(app_id).then(function (result) {
        let data = result.data;
        if (data.success) {
            $scope.recipe_ingredients_attributes = data.attributes;
            angular.forEach($scope.recipe_ingredients_attributes, function (attribute, key) {
                if (!$scope.ingredient.attributes[key] && $scope.recipe_ingredients_attributes[key].default) {
                    $scope.ingredient.attributes[key] = $scope.recipe_ingredients_attributes[key].default;
                }
            });
            $scope.isLoading = false;
        } else {
            $scope.isLoading = false;
        }
    });

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.ingredientForm.$valid) {
            $scope.isLoading = true;
            RecipeIngredient.editByExternal($scope.ingredient).then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.RECIPES.GROWL.INGREDIENT.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                    $modalInstance.close();
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.RECIPES.GROWL.INGREDIENT.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
}]);

recipesControllers.controller('RecipesTagsController', ['$scope', '$rootScope', '$state', '$stateParams', 'NgTableParams', 'growl', 'AppsoupAPI', 'Permissions', 'RecipesTag', '$filter', function ($scope, $rootScope, $state, $stateParams, NgTableParams, growl, AppsoupAPI, Permissions, RecipesTag, $filter) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('recipes');
    $scope.app_id = $stateParams.application_id;

    $scope.search = {};
    $scope.searchItem = null;
    $scope.check = false;

    if (angular.isDefinedNotNull($stateParams.page)) {
        $scope.search.page = $stateParams.page;
    }

    $scope.tableParams = new NgTableParams(AppsoupAPI.getIdAscTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;

            return RecipesTag.getList($scope.app_id, params._params).then(function (response) {
                params.total(response.recipes_tags.total);
                params.count(response.recipes_tags.per_page);
                params.page(response.recipes_tags.current_page);

                if (angular.isDefinedNotNull($stateParams.searchTag)) {
                    $scope.search = $stateParams.searchTag;
                    $scope.searchTag($scope.search);
                }

                return response.recipes_tags.data;
            }).finally(function () {
                $scope.isLoading = false;
                $scope.isFind = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.removeRecipesTag = function (id, index) {
        RecipesTag.remove(id).then(function (result) {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.RECIPES.GROWL.TAGS.SUCCESS.DELETED');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.RECIPES.GROWL.TAGS.ERROR.DELETED');
            }
        });
    };

    $scope.searchTag = function (search) {
        $scope.isFind = true;

        search.start_date = $filter('date')(search.start_date, 'yyyy-MM-dd');
        search.end_date = $filter('date')(search.end_date, 'yyyy-MM-dd');

        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.display_name)) {
            $scope.tableParams._params.display_name = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.start_date)) {
            $scope.tableParams._params.start_date = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.end_date)) {
            $scope.tableParams._params.end_date = undefined;
        }
        $stateParams.searchTag = null;
        $scope.searchItem = null;
    };

    $scope.$watch('search', function () {
        if (angular.isDefinedNotNull($scope.search.page)) {
            $scope.tableParams._params.page = $scope.search.page;
        }
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);
}]);

recipesControllers.controller('RecipesTagController', ['$scope', '$rootScope', '$state', '$filter', '$locale', '$stateParams', 'growl', 'RecipesTag', function ($scope, $rootScope, $state, $filter, $locale, $stateParams, growl, RecipesTag) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});

    $scope.editMode = false;
    var appId = $stateParams.application_id;
    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.tag = {
        app_id: appId
    };
    $scope.headerTitle = [];

    if (angular.isDefined($stateParams.tagId)) {
        $scope.editMode = true;
    }

    if ($scope.editMode) {
        RecipesTag.get($stateParams.tagId, appId).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.tag = data.recipes_tags;
                if (angular.isDefinedNotNull($scope.tag.image_url)) {
                    $scope.fileUploaded = true;
                }
                //$scope.selectedGender = $scope.tag.gender ? $scope.tag.gender : 'any';
                $scope.headerTitle.push('-');
                $scope.headerTitle.push($scope.tag.name);
                if ($scope.tag.display_name) {
                    $scope.headerTitle.push(' (');
                    $scope.headerTitle.push($scope.tag.display_name);
                    $scope.headerTitle.push(')');
                }
            } else {
                growl.error('MODULES.RECIPES.GROWL.TAGS.ERROR.GET_DATA');
                $state.go('appsoup.application.recipesTags', {application_id: appId});
            }
        }).catch(function () {
            $state.go('appsoup.application.recipesTags', {application_id: appId});
            growl.error('ERROR.EMPTY_DATA');
        }).finally(function () {
            $rootScope.doingResolve = false;
        });
    }

    $scope.save = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        RecipesTag.save($scope.tag, $scope.upload, $scope.editMode).then(function (result) {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.RECIPES.GROWL.TAGS.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                $state.go('appsoup.application.recipesTags', {application_id: appId});
            } else {
                if (typeof data.error === 'object') {
                    if (data.error.image) {
                        $scope.fileError = true;
                    }
                    $scope.formErrors = data.error;
                } else {
                    growl.error('MODULES.RECIPES.GROWL.TAGS.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                }
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.recipesTags', {application_id: appId});
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'start_date': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'end_date': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'image_url': [{type: '$invalid', msg: 'FORM.ERRORS.FORMAT'}],
        'min_age': [{error: 'max', msg: 'ERROR.MIN_AGE_BIGGER_MAX'}, {error: 'min', msg: 'ERROR.MIN_AGE_ZERO'}],
        'max_age': [{error: 'min', msg: 'ERROR.MAX_AGE_SMALLER_MIN'}]
    };
}]);

recipesControllers.controller('RecipePostsImportController', ['$state', '$scope', '$rootScope', '$stateParams', 'growl', 'Recipe', '$filter', '$locale', function ($state, $scope, $rootScope, $stateParams, growl, Recipe, $filter, $locale) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }
    $scope.editMode = false;

    $scope.requiredFields = [
        '"NAZWA PRZEPISU"',
        '"LINK"',
        '"TRESC POSTA"'
    ];

    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.errorRequired = false;

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.errorRequired = true;
        $scope.fileUploaded = false;
    };

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.errorRequired = false;
        $scope.fileUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };

    $scope.importData = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        Recipe.importData($scope.application_id, $scope.upload).then(function (result) {
            let data = result.data;
            if (data.success) {
                $scope.imported = true;
                growl.success('MODULES.APPLICATIONS.MODULES.USERS.IMPORT.SUCCESS');
                $scope.upload = undefined;
                $scope.fileUploaded = false;
            } else {
                growl.error(data.error, {title: 'IMPORT.HEADER.DEFAULT'});
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.recipes');
    };
}]);

export default recipesControllers;
